var map = {
	"./cs.json": 4051,
	"./de.json": 5013,
	"./es.json": 7791,
	"./fr.json": 6453,
	"./hu.json": 6531,
	"./it.json": 5388,
	"./ro.json": 4028,
	"./sk.json": 7389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;